import { UseQueryOptions, useQuery } from 'react-query'
import { CouponCodesApi } from '@trybeapp/sdk.shop'
import { LegacySdkResponseError } from 'api/api.types'

const api = new CouponCodesApi()

export const useGetApplicableOfferingsForCouponCode = (
  code?: string,
  options?: UseQueryOptions<any, LegacySdkResponseError>
) => {
  return useQuery<any, LegacySdkResponseError>(
    ['couponCodeApplicableOfferings', code],
    () => api.getCouponOfferingDiscounts(code),
    options
  )
}
